const list = {
    path: 'payChannelInterface',
    component: resolve => require(['@/pages/admin/system/payChannelInterface'], resolve)
}

export default list